var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t(_vm.isEdit ? "editUser" : "addUser"),
      rightMethod: _vm.onSubmitted,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              [
                _c(
                  "v-flex",
                  { attrs: { md4: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("email"),
                        rules: [_vm.fieldIsRequired("Email")],
                        readonly: _vm.isEdit
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return function() {
                            return false
                          }.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.user.email,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.user,
                            "email",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "user.email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { md1: "" } }),
                _vm._v(" "),
                _vm.isEdit
                  ? _c(
                      "v-flex",
                      { attrs: { md4: "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: _vm.$t("name"),
                            readonly: _vm.isEdit
                          },
                          model: {
                            value: _vm.user.name,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "name", $$v)
                            },
                            expression: "user.name"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-list",
              { attrs: { subheader: "", "three-line": "" } },
              [
                _c("v-subheader", [_vm._v(_vm._s(_vm.$t("roles")))]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { wrap: "" } },
                  [
                    _vm._l(_vm.roles, function(item) {
                      return _c(
                        "v-flex",
                        { key: item.key, attrs: { md6: "" } },
                        [
                          _c(
                            "v-list-tile",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  item.isSelected = !item.isSelected
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c("v-checkbox", {
                                    attrs: { value: item.isSelected },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        item.isSelected = !item.isSelected
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-list-tile-title",
                                    { staticClass: "text-capitalize" },
                                    [_vm._v(_vm._s(item.text))]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.roleToComponentMap
                                          .get(item.key)
                                          .join(", ")
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.isWarehouseOwner
                      ? _c(
                          "v-flex",
                          { attrs: { md5: "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.warehousesSites,
                                label: _vm.$t("warehouseSites"),
                                multiple: "",
                                chips: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "prepend-item",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-list-tile",
                                          {
                                            attrs: { ripple: "" },
                                            on: {
                                              mousedown: function($event) {
                                                $event.preventDefault()
                                              },
                                              click: _vm.selectAll
                                            }
                                          },
                                          [
                                            _c(
                                              "v-list-tile-action",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "#224855" }
                                                  },
                                                  [_vm._v(_vm._s(_vm.allIcon))]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("selectAll")
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider", { staticClass: "mt-2" })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3568116701
                              ),
                              model: {
                                value: _vm.filterWarehouseSites,
                                callback: function($$v) {
                                  _vm.filterWarehouseSites = $$v
                                },
                                expression: "filterWarehouseSites"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.isEdit
              ? _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-textarea", {
                          attrs: {
                            label: _vm.$t("note"),
                            outline: "",
                            rows: "3",
                            counter: 200,
                            "auto-grow": ""
                          },
                          model: {
                            value: _vm.user.note,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.user,
                                "note",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "user.note"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf67ff9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf67ff9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PermissionEditPopup.vue
// module id = null
// module chunks = 